* {
  box-sizing: border-box;
}

gz-collapsible-panel.item-panel {
  --panel-header-padding: 0;
  --panel-content-padding: 0;
  position: relative;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 11.5px;
    width: 1px;
    background-color: var(--chart-101-pressed-dividers);
  }

  &::before {
    top: 0;
    height: 12px;
  }

  &::after {
    bottom: 0;
    height: calc(100% - 20px);
  }
}

gz-collapsible-panel.item-panel[isOpen] {
  &::after {
    background-color: var(--blue-layout-300-active);
  }
}

gz-collapsible-panel.item-panel[isOpen]::part(panel-header) {
  background-color: var(--blue-layout-050-selected);
}

gz-collapsible-panel.item-panel::part(panel-header) {
  width: 100%;
  border: none;
  background-color: var(--white-layout-301-level-0-elevation);
}

gz-collapsible-timeline-item {
  width: 100%;
}

:host {
  display: block;
  max-width: 100%;
  cursor: pointer;
  background-color: transparent;
  position: relative;
}

:host([isOpen]) {
  .timeline-item {
    &--bullet {
      .circle {
        background-color: var(--blue-layout-300-active);

        .count {
          color: var(--white-layout-301-level-0-elevation);
        }
      }
    }
  }
}

:host([lastItem]) {
  .timeline-item {
    &--bullet {
      &::before {
        height: 16px;
      }
    }
  }
}

.timeline-item {
  display: flex;
  min-height: calc(4 * var(--spacer));
  padding-left: var(--spacer);
  &--bullet {
    position: relative;
    width: calc(3 * var(--spacer));
    height: calc(3 * var(--spacer));
    border: 1px solid transparent;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transform: translate(-8px, 4px);
    .circle {
      width: var(--spacer);
      height: var(--spacer);
      border-radius: 50%;
      background-color: var(--chart-101-pressed-dividers);
      display: flex;
      justify-content: center;
      align-items: center;
      .count {
        font-size: var(--body-size-xsmall);
        color: var(--main-titles-inputs-600);
      }

      &.has-count {
        width: 20px;
        height: 20px;
      }
    }
  }
  &--summary {
    display: flex;
    gap: var(--spacer);
    flex: 1;
    justify-content: space-between;
    max-width: calc(100% - calc(4 * var(--spacer)));
    padding-top: 4px;

    .summary {
      flex-grow: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      white-space: nowrap;
    }

    .suffix {
      flex: 0;
    }
  }
  &--content {
    padding: 12px 0 12px calc(4 * var(--spacer));
  }
  &--label {
    font-size: var(--body-size);
    line-height: 1.5;
    font-family: var(--font-family);
    display: inline;
  }
  &--details {
    margin-top: 2px;
    margin-bottom: 4px;
    color: var(--chart-302-icon-buttons-titles);
    font-size: var(--body-size-xsmall);
    line-height: 1.5;
    font-family: var(--font-family-secondary);
  }
}

:host([isEmphasized]) {
  .timeline-item {
    &--bullet {
      border-color: var(--chart-101-pressed-dividers);
    }
  }
}

:host([isEmphasized][isOpen]) {
  .timeline-item {
    &--bullet {
      border-color: var(--blue-layout-300-active);
    }
  }
}

:host([groupedentriescount]) {
  gz-collapsible-panel.item-panel {
    &::before {
      height: 6px;
    }
    &::after {
      height: calc(100% - 26px);
    }
  }
}
